import React, {Fragment, FunctionComponent} from "react";
import {useTranslation} from "react-i18next";
import {LocationFilter} from "@App/Components/Filters";
import {Place, Service} from "@App/types";
import {ServiceIsElectronicLicenseControl, ServiceIsVehicleReturn} from "@App/utils/conditionals/services";

type LocationStepProps = {
    submit: any,
    service?: Service,
    place?: Place
};

export const LocationStep: FunctionComponent<LocationStepProps> = (props: LocationStepProps)  => {

    const {t} = useTranslation()


    return (
        <Fragment>
            <div className={`pb-32 md:pb-20`}>
                <div className={`md:w-80`}>
                    <LocationFilter className="relative" onSubmit={props.submit}/>
                </div>
                <div
                    onClick={props.submit}
                    className={`${!props.service || (!props.place || !props.place.lat) ? 'cursor-pointer pointer-events-none no-underline' : ''}`}>
                    <div
                        className={`${!props.service || !props.place ? 'bg-primary-100' : 'bg-primary'} w-full md:w-80 px-8 py-2 mt-4 text-white rounded text-center font-serif font-bold cursor-pointer no-underline`}>
                        {props.service && ServiceIsVehicleReturn(props.service) ? t('Rueckgabestation suchen') : (ServiceIsElectronicLicenseControl(props.service) ? t('homeHints.searchTestCenter') : t('Werkstatt suchen'))}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
